import i18n from '@/i18n/config';
import { useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { createTableQueryOptions } from '@/components/table';

interface ShopOption {
  key: string;
  label: string;
}

interface ShopOptionsResponse {
  success: boolean;
  data: Array<{ name: string; key: string }>;
}

// Fallback shop options (in case API is not ready)
const FALLBACK_SHOP_OPTIONS: ShopOption[] = [
  { key: 'WooCommerce', label: i18n.t('copy.woocommerce') },
  { key: 'Shopify', label: i18n.t('copy.shopify') },
  { key: 'PrestaShop', label: i18n.t('copy.prestashop') },
  { key: 'Magento', label: i18n.t('copy.magento') },
  { key: 'OpenCart', label: i18n.t('copy.opencart') },
  { key: 'BigCommerce', label: i18n.t('copy.bigcommerce') },
  { key: 'Wix', label: i18n.t('copy.wix') },
  { key: 'Squarespace', label: i18n.t('copy.squarespace') },
  { key: 'DrupalCommerce', label: i18n.t('copy.drupalcommerce') },
  { key: 'VirtueMart', label: i18n.t('copy.virtuemart') },
  { key: 'Shopware', label: i18n.t('copy.shopware') },
  { key: 'VTEX', label: i18n.t('copy.vtex') },
  { key: 'SalesforceCommerceCloud', label: i18n.t('copy.salesforce_commerce_cloud') },
  { key: 'SAP_Hybris', label: i18n.t('copy.sap_hybris') },
  { key: 'CommerceTools', label: i18n.t('copy.commercetools') },
  { key: 'Medusa', label: i18n.t('copy.medusa') }
];

// Query atom for shop options
// Note: API endpoint /ecommerce-platforms doesn't exist, so we always use fallback
export const shopOptionsQueryAtom = atomWithQuery<ShopOptionsResponse>((get) => {
  return createTableQueryOptions({
    queryKey: ['shop-options'] as const,
    queryFn: async () => {
      // API endpoint doesn't exist, always return fallback
      return {
        success: true,
        data: FALLBACK_SHOP_OPTIONS.map(opt => ({ name: opt.label, key: opt.key }))
      };
    },
    enabled: true
  });
});

export function useShopOptions(): ShopOption[] {
  const query = useAtomValue(shopOptionsQueryAtom);
  
  if (query.data?.data) {
    return query.data.data.map(item => ({
      key: item.key,
      label: item.name
    }));
  }
  
  // Return fallback if API hasn't loaded or failed
  return FALLBACK_SHOP_OPTIONS;
}



